import React from 'react'
import { useFetch } from '../../hooks/useFetch'
import { Container, Box, Grid, TextField, Typography, Button, Divider, Card, Paper, CardActions, CardContent } from '@mui/material/'
import { useState, useEffect } from 'react';
import { OutlinedInput, InputLabel, FormControl, Select, MenuItem } from '@mui/material/'
import SelectSaProvince from '../SelectSaProvince'
function ViewDelivery({ setViewDelivery, studentId, quoteId, setViewTerms }) {

    const { error, errorMessage, isPending, data: deliveryInfo } = useFetch(`https://dcregapi.bi-oss.co.za/students/deliveryaddress/${studentId}`)

    const { updateData, error: error2, errorMessage: errorMessage2, isPending: isPending2, data: deliveryUpdated } = useFetch(`https://dcregapi.bi-oss.co.za/quote/deliveryprefrence/${quoteId}`, 'PUT')



    const [courier, setCourier] = useState('')


    const [numberunit, setNumberUnit] = useState('')
    const [street, setStreet] = useState('')
    const [suburb, setSuburb] = useState('')
    const [city, setCity] = useState('')
    const [province, setProvince] = useState('')
    const [country, setCountry] = useState('South Africa')
    const [code, setCode] = useState('')
    const [contact, setContact] = useState('')
    const [contactTel, setContactTel] = useState('')



    useEffect(() => {
        if (deliveryInfo) {

            deliveryInfo.map(data => {
                setNumberUnit(data.numberunit)
                setStreet(data.street)
                setSuburb(data.suburb)
                setCity(data.city)
                setProvince(data.province)
                setContact(data.contact)
                setContactTel(data.contactTel)
                setCode(data.code)

            })

        }
    }, [deliveryInfo])



    const handleSubmit = (e) => {
        e.preventDefault()


        updateData({
            courier,
            numberunit,
            street,
            suburb,
            city,
            province,
            code,
            contact,
            contactTel
        })
    }

    useEffect(() => {
        if (deliveryUpdated) {
            setViewDelivery(0)
            setViewTerms(1)
        }
    }, [deliveryUpdated])

    return (
        < Container maxWidth="md"  >
            <form onSubmit={handleSubmit} autoComplete="off" >
                <Box mb={5} />
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }} sx={{ border: 'solid', borderWidth: '3px', borderColor: 'primary.main', borderRadius: 2 }}>
                    <>



                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <Typography variant="h3" component="h3" color="primary.main" sx={{ textAlign: 'center' }}>
                                    Course Material
                                </Typography>



                            </Box>


                        </Grid>

                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <Typography variant="h4" component="h4" color="primary.main" sx={{ textAlign: 'center' }}>
                                    (Collection or Delivery)
                                </Typography>



                            </Box>


                        </Grid>
                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                    Once an order is placed, the student’s course materials are ordered. Course materials can take from 10 to 14 days to obtain excluding delivery. Once the materials are made available, they can either be couriered to your selected delivery address or collected from <b>130 Bryanston Drive, Bryanston, Johannesburg</b>.
                                </Typography>



                            </Box>


                        </Grid>
                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <Typography variant="body2" component="p" color="primary.main" sx={{ textAlign: 'center' }}>
                                    <i>We recommend that Johannesburg based students collect their material. As this allows the student the opportunity to meet their Student Advisor and discuss their academic goals.  </i>
                                </Typography>



                            </Box>


                        </Grid>

                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >    <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}

                                    >
                                        <FormControl fullWidth>
                                            <InputLabel id="deliveryId">Select Preference. </InputLabel>
                                            <Select
                                                labelId="deliveryId"
                                                id="deliveryId"
                                                value={courier}
                                                label="Select Gender*"
                                                onChange={(e) => setCourier(e.target.value)}
                                                required

                                            >



                                                <MenuItem key="1" value={0}>Collection</MenuItem>
                                                <MenuItem key="2" value={1}>Courier</MenuItem>


                                            </Select>
                                        </FormControl>
                                    </Box>


                                </Grid>

                            </Box>


                        </Grid>


                        {courier === 1 && (
                            <>

                                <Grid item xs={12} >
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"

                                    >

                                        <Typography variant="body2" component="p" color={"secondary.main"} sx={{ textAlign: 'center' }}>
                                            BIDC only courier’s materials and items within South Africa. Any international students will need to either collect their material or arrange for their own external courier to collect the material.
                                        </Typography>


                                    </Box>
                                </Grid>


                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >


                                        <SelectSaProvince province={province} setProvince={setProvince} />







                                    </Box>


                                </Grid>


                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >




                                        <TextField

                                            id="city"
                                            label="City/Town"
                                            value={city}
                                            onChange={(e) => setCity(e.target.value)}
                                            fullWidth
                                            required
                                            autoComplete='nope'
                                            inputProps={{ maxLength: 100, minLength: 3, style: { textTransform: "capitalize" } }}
                                        />



                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >




                                        <TextField

                                            id="suburb"
                                            label="Suburb"
                                            value={suburb}
                                            onChange={(e) => setSuburb(e.target.value)}
                                            fullWidth
                                            required
                                            autoComplete='nope'
                                            inputProps={{ maxLength: 100, minLength: 3, style: { textTransform: "capitalize" } }}
                                        />



                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >




                                        <TextField

                                            id="street"
                                            label="Street Name"
                                            value={street}
                                            onChange={(e) => setStreet(e.target.value)}
                                            fullWidth
                                            required
                                            autoComplete='nope'
                                            inputProps={{ maxLength: 100, minLength: 3, style: { textTransform: "capitalize" } }}
                                        />



                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >




                                        <TextField

                                            id="numberunit"
                                            label="House/Building/Apartment Number"
                                            value={numberunit}
                                            onChange={(e) => setNumberUnit(e.target.value)}
                                            fullWidth
                                            required
                                            autoComplete='nope'
                                            inputProps={{ maxLength: 100, minLength: 3, }}
                                        />



                                    </Box>


                                </Grid>

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >




                                        <TextField

                                            id="code"
                                            label="Area/Postal/Zip Code"
                                            value={code}
                                            onChange={(e) => setCode(e.target.value)}
                                            fullWidth
                                            required
                                            autoComplete='nope'
                                            inputProps={{ maxLength: 20, minLength: 4, }}
                                        />



                                    </Box>


                                </Grid>
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >




                                        <TextField

                                            id="contact"
                                            label="Courier Contact Person"
                                            value={contact}
                                            onChange={(e) => setContact(e.target.value)}
                                            fullWidth
                                            required
                                            autoComplete='nope'
                                            inputProps={{ maxLength: 100, minLength: 3, }}
                                        />



                                    </Box>


                                </Grid>
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}
                                    >
                                        <TextField

                                            id="contactTel"
                                            label="Contact Tel:"
                                            onChange={(e) => setContactTel(e.target.value)}
                                            value={contactTel}
                                            fullWidth
                                            type="tel"
                                            inputProps={{ maxLength: 10, minLength: 10, }}
                                            autoComplete='nope'
                                            required

                                        />


                                    </Box>


                                </Grid>

                            </>
                        )}



                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >
                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}

                                    >
                                        <Button fullWidth type="submit" color="primary" variant="contained">Continue</Button>

                                    </Box>


                                </Grid>
                            </Box>


                        </Grid>

                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >


                                <Divider style={{ width: '100%', color: "primary.main" }} />
                            </Box>

                        </Grid>



                        <Grid item xs={12}>

                            <Box
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                sx={{

                                    maxWidth: '95%',
                                    marginLeft: 'auto',
                                    marginRight: 'auto'
                                }}
                            >

                                <Grid item xs={4} sm={4} md={6} lg={6} xl={6}>

                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        sx={{

                                            maxWidth: '95%',
                                            marginLeft: 'auto',
                                            marginRight: 'auto'
                                        }}

                                    >
                                        <Button fullWidth onClick={(e) => setViewDelivery(0)} color="primary" variant="contained">Cancel</Button>

                                    </Box>


                                </Grid>

                            </Box>

                            <Box mb={5} />
                        </Grid>
                        {/* <Grid item xs={12}>

                            {isPending && !error && (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"

                                >
                                    <Typography variant="h6" component="h3" color="primary">
                                        Fetching quote details ........
                                    </Typography>
                                </Box>
                            )}

                            {error && !errorMessage && (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"

                                >
                                    <Typography variant="h6" component="h3" color="error">
                                        Unable to fetch quote details. You may be offline. Please try again.


                                    </Typography>
                                </Box>
                            )}
                            {errorMessage && (
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"

                                >
                                    <Typography variant="h6" component="h3" color="error">
                                        {errorMessage}


                                    </Typography>
                                </Box>
                            )}

                        </Grid> */}
                    </>
                </Grid>
            </form>
        </Container>

    )
}

export default ViewDelivery